import { Injectable } from '@angular/core';
import { Observable, Subject, BehaviorSubject } from 'rxjs';

import { Model, ModelFactory } from '@angular-extensions/model';

import { RangeMonthType, ReportFilter, ISettingsFilter, SettingsFilter, ValuationModel, IFilterBaseModel, FilterBaseModel, IMarketModel, MarketModel } from '../../models';

import { LocalStoreManager } from '@app/shared/services/local-store-manager.service';
import { DBkeys } from '@app/settings';

const initialData: ISettingsFilter = new SettingsFilter(10, 'gb', 'Car', 36, 60);
const initialFilterBase: IFilterBaseModel = FilterBaseModel.empty();

import * as _ from 'lodash';

@Injectable({
  providedIn: 'root'
})
export class ReportFilterService {//old style migrate to user****-state.service

  private _filter = new Subject<ReportFilter>();
  private _filterSettings = new BehaviorSubject<SettingsFilter>((initialData as SettingsFilter));

  //consume events - this.subscription = this.reportFilterService.filter$.subscribe(n => {  this.reportFilter = n; });
  public filter$ = this._filter.asObservable();
  public filterSettings$ = this._filterSettings.asObservable();

  //rise an event -  this.reportFilterService.filterChanged(filter: ReportFilter);
  public filterChanged(filter: ReportFilter): void {
    this._filter.next(filter);
  }

  public filterSettingsChanged(filter: SettingsFilter): void {
    this._filterSettings.next(filter);
  }


  //current multi countries and vtypes way 17.07.2020 // not used 06.08.2020
  private _model: Model<IFilterBaseModel>;
  active$: Observable<IFilterBaseModel>;

  constructor(
    private _modelFactory: ModelFactory<IFilterBaseModel>,
    private readonly _localStorage: LocalStoreManager,
  ) {
    var filterBaseLastState = this.loadLocalStore<IFilterBaseModel>(DBkeys.FILTER_BASE);
    this._model = this._modelFactory.create({ ...initialFilterBase, ...filterBaseLastState });
    this.active$ = this._model.data$;
  }

  get currentActive(): IFilterBaseModel {
    return this._model.get();
  }

  update(model?: IFilterBaseModel) {
    const vModel = this._model.get();

    if (model) {
      model.countryIds && model.countryIds.length > 0 && (vModel.countryIds = model.countryIds);
      model.vTypes && model.vTypes.length > 0 && (vModel.vTypes = model.vTypes);

      this._model.set(vModel);
    }

    this.saveToLocalStore(_.cloneDeep(vModel), DBkeys.FILTER_BASE);
  }
  //not used
  updateFromMarketModel(model: IMarketModel[]) {
    const vModel = this._model.get();

    if (model.length) {
      vModel.countryIds = [...new Set(model.map(item => item.countryId))].sort();
      vModel.vTypes = [...new Set(model.map(item => item.vType))].sort();

      this._model.set(vModel);
    }

    this.saveToLocalStore(_.cloneDeep(vModel), DBkeys.FILTER_BASE);
  }

  private loadLocalStore<T>(key: string) {

    if (this._localStorage.exists(key))
      return this._localStorage.getDataObject<T>(key);
  }
  private saveToLocalStore(data: any, key: string) {
    setTimeout(() =>
      this._localStorage.saveSessionData(data, key)
    );
  }
}
